import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { KioskService } from '../kiosk.service';

@Component({
  selector: 'app-kiosk-edit-dialog',
  templateUrl: './kiosk-edit-dialog.component.html',
  styleUrls: ['./kiosk-edit-dialog.component.css']
})
export class KioskEditDialogComponent implements OnInit {
  kiosk;
  kioskInProgress;
  loading = false;
  constructor(
    public dialogRef: MatDialogRef<KioskEditDialogComponent>,
    private _kioskService: KioskService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { kiosk: any }) { }


  ngOnInit() {
    this.kiosk = this.data.kiosk;
  }

  kioskChanged(k: any) {
    this.kioskInProgress = k;
  }


  saveKiosk() {
    this.loading = true;
    this._kioskService.updateKiosk(this.kiosk.id, this.kioskInProgress).subscribe((d) => {
      this.loading = false;

      this.dialogRef.close('refresh');
    }, (error) => {
      this.snackBar.open('Error:' + error.error.code, 'Okay', {
        duration: 2000,
      });
      this.loading = false;

      console.log('an error occurred', error);
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/kiosk-edit-dialog/kiosk-edit-dialog.component.ts